/*
 *
 * GaleryPage reducer
 *
 */

import {
  FETCH_GALLERY_REQUEST,
  FETCH_GALLERY_SUCCESS,
  FETCH_GALLERY_FAILURE,
  DELETE_GALLERY_REQUEST,
  DELETE_GALLERY_SUCCESS,
  DELETE_GALLERY_FAILURE,
} from "./constants";

const initialState = {
  channel: null,
  isFetching: false,
  error: null,
  deleting: false,
  deletedGifId: null,
};

function galeryPageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GALLERY_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_GALLERY_SUCCESS:
      return {
        ...state,
        channel: action.payload,
        isFetching: false,
      };
    case FETCH_GALLERY_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };
    case DELETE_GALLERY_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case DELETE_GALLERY_SUCCESS:
      return {
        ...state,
        deleting: false,
        deletedGifId: action.payload?.gifId,
      };
    case DELETE_GALLERY_FAILURE:
      return {
        ...state,
        deleting: false,
      };
    default:
      return state;
  }
}

export default galeryPageReducer;
